import { createStyles, Theme } from '@material-ui/core';

import { styleFormIoComponent } from '#web-components/styles/form';
import { COMPONENT_CLASSES } from '../../constants';

export default (theme: Theme) => createStyles({
  '@global': styleFormIoComponent(COMPONENT_CLASSES.datetime, theme),
});
